$('#KennwortAnfordern').on('click', function () {
	const email = $('#Login').val();
	$('form[action="/approot/de-de/10/Kennwort/NeuesAnfordern"]').validate({
		rules: {
			Login: 'required',
		},
		messages: {
			Login: Strings.BenutzernameNichtGefuellt,
		},
		errorClass: 'error small',
	});
	if (email === '') {
		$('form[action="/approot/de-de/10/Kennwort/NeuesAnfordern"]').validate().element('#Login');
	} else {
		$(this).closest('form')[0].submit();
	}
});
